import { Close } from '@mui/icons-material';
import { HOME_CHAT_SUGGESTION_COUNT, homeChatSuggestionIdentity } from '../utils/homeChatSuggestions';
const SUGGESTION_LOADING_WIDTHS = Array(HOME_CHAT_SUGGESTION_COUNT).fill('63%');

const HomeFocusedSuggestions = ({
    dismissingSuggestionIdentity,
    disabled,
    loading,
    onDismissSuggestion,
    onSelectSuggestion,
    suggestions,
}) => (
    <div className='homeFocusedSuggestions'>
        {loading ? SUGGESTION_LOADING_WIDTHS.map((width, index) => (
            <div
                className='homeSuggestionRow homeSuggestionLoadingRow'
                role={index === 0 ? 'status' : undefined}
                aria-label={index === 0 ? 'Loading suggestions' : undefined}
                aria-hidden={index === 0 ? undefined : 'true'}
                key={`suggestion-loading-${index}`}
            >
                <span className='loading homeSuggestionLoadingEmoji' aria-hidden='true' />
                <span
                    className='loading homeSuggestionLoadingText'
                    style={{ width }}
                    aria-hidden='true'
                />
            </div>
        )) : suggestions.map((suggestion) => {
            const personal = suggestion.kind === 'personal';
            const suggestionIdentity = homeChatSuggestionIdentity(suggestion);
            const dismissing = suggestionIdentity === dismissingSuggestionIdentity;

            return (
                <div
                    className='homeSuggestionRow'
                    data-suggestion-kind={suggestion.kind}
                    data-suggestion-text={suggestion.text}
                    key={suggestionIdentity}
                >
                    <button
                        type='button'
                        className='homeSuggestionMainButton'
                        onClick={() => onSelectSuggestion(suggestion)}
                        disabled={disabled}
                        aria-label={`${suggestion.text}. ${personal ? 'Starts a new chat' : 'Opens example chat'}`}
                    >
                        <span className='homeSuggestionEmoji' aria-hidden='true'>
                            {suggestion.emoji}
                        </span>
                        <span className='homeSuggestionText'>
                            {suggestion.text}
                        </span>
                    </button>

                    <button
                        type='button'
                        className='homeSuggestionDismissButton'
                        onClick={() => onDismissSuggestion(suggestion)}
                        disabled={disabled}
                        aria-label={`Dismiss ${suggestion.text}`}
                    >
                        {dismissing ? (
                            <span className='homeSuggestionSpinner homeSuggestionDismissSpinner' aria-hidden='true' />
                        ) : (
                            <Close aria-hidden='true' style={{ fontSize: '18px' }} />
                        )}
                    </button>
                </div>
            );
        })}
    </div>
);


export default HomeFocusedSuggestions;
